import { clickedOnLoggedOutPage } from '@bridebook/web/app-basic/lib/analytics/tracking-actions/logged-out-page-click';
import { getActualCategory } from '@bridebook/web/app-basic/lib/search/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { cn } from '@bridebook/aura';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';

interface IProps {
  href: string;
  label: string;
  isSelected?: boolean;
}

const SearchFacetsPill = ({ href, label, isSelected }: IProps) => {
  const dispatch = useDispatch();
  const actualCategory = useSelector(getActualCategory);
  const { country } = useMarket();

  const onFacetClick = useCallback(() => {
    dispatch(
      clickedOnLoggedOutPage({
        clickedLocation: 'search',
        clickedSection: 'facet',
        cta: label,
        supplierCountryCode: country,
        supplierCategory: actualCategory,
      }),
    );
  }, [actualCategory, country, dispatch, label]);

  return (
    <a
      href={href}
      onClick={onFacetClick}
      className={cn('bsfacet', isSelected && 'bsfacet-selected')}>
      {label}
    </a>
  );
};

export default SearchFacetsPill;
